import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {PanicButtonPopupBox} from "./boxes/panic-button-popup.box";
import React from 'react';
import {TimeSpan} from "@sparkware/app-utils";
import {IModalDialogHandler} from "../../../../../services/dialog/dialog.service.interface";
import {PanicButtonPopupTimeBox} from "./boxes/panic-button-popup-time.box";
import {PanicButtonPopupOkBox} from "./boxes/panic-button-popup-ok.box";
import { DialogTextBox } from "../../../../modal-dialog/boxes/text/dialog-text.box";
import { ModalDialogActionsComponent } from "../../../../modal-dialog/modal-dialog-actions.component";

interface PanicButtonPopupComponentProps{
    textMessage1:string,
    textMessage2:string,
    textMessage3:string,
    dialogHandler: IModalDialogHandler;
}

export class PanicButtonPopupComponent extends OrbitComponent<PanicButtonPopupComponentProps>{

    private _getTime():string{
        const now = this.services.time.getCurrentDate();
        return new TimeSpan(0,now.getHours(),now.getMinutes()).toString();
    }

    private _closeDialog = () => {
        this.props.dialogHandler.close();
    }

    render(){
        return (
            <PanicButtonPopupBox>
                <DialogTextBox>{this.props.textMessage1}</DialogTextBox>
                <DialogTextBox>
                    {this.props.textMessage2}
                    <PanicButtonPopupTimeBox>{this._getTime()}</PanicButtonPopupTimeBox>
                    {this.props.textMessage3}
                </DialogTextBox>
                <PanicButtonPopupOkBox>
                    <ModalDialogActionsComponent primaryAction={{
                        onClick: this._closeDialog,
                        text: this.services.translation.translate('OK')
                    }} />
                </PanicButtonPopupOkBox>
            </PanicButtonPopupBox>
        )
    }
}